import { __exports as i } from "../../../_virtual/cvv.js";
Object.defineProperty(i, "__esModule", { value: !0 });
i.cvv = void 0;
var n = 3;
function u(e, r) {
  for (var t = 0; t < e.length; t++)
    if (r === e[t])
      return !0;
  return !1;
}
function l(e) {
  for (var r = n, t = 0; t < e.length; t++)
    r = e[t] > r ? e[t] : r;
  return r;
}
function f(e, r) {
  return { isValid: e, isPotentiallyValid: r };
}
function o(e, r) {
  return r === void 0 && (r = n), r = r instanceof Array ? r : [r], typeof e != "string" || !/^\d*$/.test(e) ? f(!1, !1) : u(r, e.length) ? f(!0, !0) : e.length < Math.min.apply(null, r) ? f(!1, !0) : e.length > l(r) ? f(!1, !1) : f(!0, !0);
}
i.cvv = o;
export {
  i as default
};
